import { useState } from 'react';

export default function About() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      quote: "The drivers are always on time, professional, and genuinely caring. They helped my mother get to her dialysis appointments three times a week for over a year. I can't thank them enough for their reliability and compassion during such a difficult time.",
      author: "Sarah M., Phoenix, AZ"
    },
    {
      quote: "After my surgery, I needed wheelchair transportation for physical therapy. The team was incredibly patient and made sure I was comfortable every single trip. Their attention to detail and safety protocols gave me complete peace of mind.",
      author: "Robert T., Denver, CO"
    },
    {
      quote: "As a case manager, I've worked with many transportation services. This company stands out for their professionalism, punctuality, and genuine care for patients. They've never let us down, and our clients always feel safe and respected.",
      author: "Linda K., Seattle, WA"
    }
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="w-full h-96 lg:h-full rounded-3xl overflow-hidden bg-teal-100">
              <img
                src="https://public.readdy.ai/ai/img_res/3c86c0ed172ba2a301895e86d931aa73.jpg"
                alt="Satisfied Patient"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-sm text-gray-500 mb-4">(Patient Testimonial)</p>
            <h2 className="text-5xl font-semibold text-gray-900 mb-2 leading-tight">
              Dependable Service
            </h2>
            <p className="text-4xl text-gray-400 mb-12">
              When It Matters Most
            </p>

            <div className="mb-12">
              <div className="text-xl text-gray-700 leading-relaxed mb-6">
                <i className="ri-double-quotes-l text-3xl text-teal-600 mr-2"></i>
                {testimonials[currentIndex].quote}
                <i className="ri-double-quotes-r text-3xl text-teal-600 ml-2"></i>
              </div>
              <p className="text-lg font-bold text-gray-900">
                — {testimonials[currentIndex].author}
              </p>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={handlePrev}
                className="w-12 h-12 rounded-full border-2 border-gray-300 flex items-center justify-center hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 rounded-full bg-teal-600 text-white flex items-center justify-center hover:bg-teal-700 transition-colors cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
